import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            es_style: '',
            es_title: '',
            es_backcolor: '',
            es_display: 0,
            mainFile: '',
            es_subject: '',
            es_text: '',
        }
    },
    validators: {
        es_style: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
                .maxLength(10, '제목은 최대 10글자까지 입력 가능합니다.')
        },
        es_title: function (value) {
            return Validator.value(value)
                .required('타이틀을 입력해주세요.')
                .maxLength(20, '타이틀은 최대 20글자까지 입력 가능합니다.')
        },
        es_backcolor: function (value) {
            return Validator.value(value)
                .required('배경색을 입력해주세요.');
        },
        es_display: function (value) {
            return Validator.value(value)
        },
        mainFile: function (value) {
            return Validator.value(value)
        },
        es_subject: function (value) {
            return Validator.value(value)
                .required('스타일링 제목를 입력해주세요.')
        },
        es_text: function (value) {
            return Validator.value(value)
                .required('스타일링 문구를 입력해주세요.')
        }
    },
    methods: {},
    computed: {},
}